import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { DEFAULT_GOOGLE_STATIC_MAP_CONFIG, GoogleStaticMapConfig, RmaMapMarker } from '@rma/generic/maps/domain';
import { PropertyAttributeComponent } from '@rma/public/campaigns/public/ui-campaign-attribute';
import { StaticGoogleMapWithDescriptionComponent } from '@rma/public/maps/public/orc-static-google-map-with-description';
import { MarketReportPropertyDetails } from '../domain';

@Component({
  selector: 'rma-market-report-property',
  templateUrl: './market-report-property.component.html',
  styleUrls: ['./market-report-property.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [StaticGoogleMapWithDescriptionComponent, PropertyAttributeComponent, TranslocoPipe],
})
export class MarketReportPropertyComponent {
  @Input()
  propertyDetails: MarketReportPropertyDetails | null;

  @Input()
  mapMarker: RmaMapMarker | null;

  @Input()
  isPrintMode: boolean | null = false;

  @Input()
  printedUrl: string | undefined;

  mapConfig: GoogleStaticMapConfig = {
    ...DEFAULT_GOOGLE_STATIC_MAP_CONFIG,
    height: 400,
    width: 640,
    clickToInteractive: false,
  };

  printMapConfig = {
    ...this.mapConfig,
    height: 200,
    scale: 2,
    lazy: false,
  };
}
